export default "__VITE_ASSET__e5b3f32a__"